// @flow

import {
  SET_PRE_PAYMENT_PROVIDER,
  SET_PRE_PAYMENT_PAYMENT_METHOD_ID,
  SET_PRE_PAYMENT_PAYMENT_METHOD_CONDITION_ID,
  CLEAR_PRE_PAYMENT_BUTTON,
} from 'Store/member-space/pre-payment/prePayment.constants';

import createReducer from 'Store/utils/createReducer';

const initialState = {
  selectedProviderId: null,
  paymentMethodId: null,
  paymentConditionId: null,
};

export default createReducer(initialState, {
  [SET_PRE_PAYMENT_PROVIDER](state: ReduxState, { payload }): ReduxState {
    return {
      ...state,
      selectedProviderId: payload.providerId,
    };
  },
  [SET_PRE_PAYMENT_PAYMENT_METHOD_ID](state: ReduxState, { payload }): ReduxState {
    return {
      ...state,
      paymentMethodId: payload.id,
    };
  },
  [SET_PRE_PAYMENT_PAYMENT_METHOD_CONDITION_ID](state: ReduxState, { payload }): ReduxState {
    return {
      ...state,
      paymentConditionId: payload.conditionId,
    };
  },
  [CLEAR_PRE_PAYMENT_BUTTON](): ReduxState {
    return initialState;
  },
});
